import { Component } from 'react';
import { StaticValues } from '../../../../../../../../insfrastructure/services/static_values';
import { listCities } from '../../../../../../../../insfrastructure/services/cities';
import { lookupCompanyByCNPJ } from '../../../../../../../../insfrastructure/services/companies';
import { CNPJValidator, emptyField, ErrorMessage, errorsLength, formatErrors, validateCEP, validateCNPJ, validateOptionalUrl } from '../../../../../../../../insfrastructure/utils/form-validators';
import { retrievePostcodeInfo } from '../../../../../../../../insfrastructure/services/cep';
import { formatUnitName } from '../../../../../../../../insfrastructure/utils/unit-formatter';
import { logger } from '../../../../../../../../insfrastructure/services/analytics';
import { Input } from '../../../../../../../components/input';
import CheckboxInput from '../../../../../../../components/checkbox';
import { Select } from '../../../../../../../components/select';
import ResponseModal from '../../../../../../../components/response-modal';
import companySegmentIcon from '../../../../../../../../assets/icons/company_segment.png';
import emailIcon from '../../../../../../../../assets/icons/email.png'
import linkIcon from '../../../../../../../../assets/icons/link.png';
import locationIcon from '../../../../../../../../assets/icons/location.png';
import phoneIcon from '../../../../../../../../assets/icons/phone.png';
import './styles.sass';

type Props = {
  form_data: Record<string, any>,
  onSubmit: (form: Record<string, any>) => void,
  mode?: 'full' | 'cnpj_gate',
  onCnpjGateResolved?: (
    flow: 'manager' | 'legacy',
    company_lookup?: { cnpj: string; name: string },
    form_data?: Record<string, any>
  ) => void,
  onCnpjLookupChange?: (cnpjLookup: { exists: boolean; companyName: string; checked: boolean }) => void,
  initialCnpjLookup?: { exists: boolean; companyName: string; checked: boolean }
}

export class CompanyData extends Component<Props> {
    state: any = {
      form: this.props.form_data,
      formErrors: {},
      cityOptions: [],
      segmentOptions: [],
      schoolOptions: [],
      loadingCEP: false,
      cepError: false,
      loadingCNPJLookup: false,
      cnpjLookup: this.props.initialCnpjLookup || {
        exists: false,
        companyName: '',
        checked: false
      }
    }
    timeout: any = null
    cnpjLookupTimeout: any = null
    lastRequestedCnpj: string | null = null
  
    componentDidMount() {
      this.getStaticValues();
    }

    componentWillUnmount() {
      if (this.cnpjLookupTimeout) {
        clearTimeout(this.cnpjLookupTimeout);
      }
    }

    componentDidUpdate(prevProps: Props) {
      if (this.props.initialCnpjLookup && this.props.initialCnpjLookup !== prevProps.initialCnpjLookup) {
        const { exists, companyName, checked } = this.props.initialCnpjLookup;
        if (
          this.state.cnpjLookup.exists !== exists ||
          this.state.cnpjLookup.companyName !== companyName ||
          this.state.cnpjLookup.checked !== checked
        ) {
          this.setState({ cnpjLookup: { exists, companyName, checked } });
        }
      }
    }
  
    getStaticValues = async () => {
        try {  
          setTimeout(() => {
            const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;          
            const segmentOptions = Object.keys(staticValues.segment)
              .map((key: any) => ({ value: key, label: staticValues.segment[key] }))
              .sort((a, b) => a.label.localeCompare(b.label));
            
            const schoolOptions = Object.values(staticValues.em_unit)
              .map((x: any) => {
                const { formatted, nameOnly } = formatUnitName(x.name);
                return { value: x.id, label: formatted, nameOnly };
              })
              .sort((a, b) => a.nameOnly.localeCompare(b.nameOnly, 'pt-BR', { sensitivity: 'base' }))
              .map(({ value, label }) => ({ value, label }));
            
            this.setState({ segmentOptions, schoolOptions });
          }, 1000);
        } catch (error) {}
    }
  
    onCityNameChange = async (e: any) => {
      const cityOptions = (await listCities(e)).map(x => ({ value: x.id, label: x.name }));
  
      this.setState({ cityOptions });
  
      return cityOptions;
    }
  
    onCEPChange = async (value: any) => {
      clearTimeout(this.timeout);
      
      // Limpar erro quando o usuário começar a digitar novamente
      if (this.state.cepError) {
        this.setState({ 
          cepError: false,
          formErrors: { ...this.state.formErrors, postcode: [] }
        });
      }
      
      if(validateCEP(value) === '') {
        this.setState({ loadingCEP: true });
      } else {
        this.setState({ loadingCEP: false });
        return;
      }
      
      this.timeout = setTimeout(async () => {
        let street = '';
        let address_district = '';
        let city_id = '';
        let city = '';
        let uf = '';
        let result = null;
  
        if(validateCEP(value) === '') {
          try {
            result = await retrievePostcodeInfo(value);
          } catch (error) {
            this.setState({
              responseData: {
                type: 'error',
                title: 'CEP Inválido',
                text: ''
              },
              loadingCEP: false,
              cepError: true,
              formErrors: {
                ...this.state.formErrors,
                postcode: ['Digite um CEP válido']
              }
            });
  
            return;
          };
  
          const cityOptions = await this.onCityNameChange(result.cidade);
  
          street = result.logradouro;
          address_district = result.bairro;
          city_id = result.city_id + '';        
          const foundCity = cityOptions.find(x => x.value === city_id);
          city = foundCity ? foundCity.label : result.cidade || '';
          uf = result.uf;
        };
    
        // Montar endereço completo com espaços após vírgulas: "Rua, Bairro, Cidade, UF"
        const addressParts = [street, address_district, city, uf].filter(part => part && part.trim() !== '');
        const fullAddress = addressParts.join(', ');

        this.setState({
          form: {
            ...this.state.form,
            street,
            address_district,
            city_id,
            city,
            uf,
            address: fullAddress
          },
          loadingCEP: false,
          cepError: false,
          formErrors: {
            ...this.state.formErrors,
            postcode: []
          }
        });
      }, 1000);
    }

    onCNPJChange = (value: string) => {
      this.setState({
        form: { ...this.state.form, cnpj: value },
        formErrors: { ...this.state.formErrors, cnpj: [] }
      });

      if (this.props.mode !== 'cnpj_gate') {
        return;
      }

      clearTimeout(this.cnpjLookupTimeout);

      const normalized = value.replace(/\D/g, '');
      this.lastRequestedCnpj = normalized;
      if (normalized.length < 14) {
        const cnpjLookup = { exists: false, companyName: '', checked: false };
        this.setState({
          loadingCNPJLookup: false,
          cnpjLookup
        });
        this.props.onCnpjLookupChange && this.props.onCnpjLookupChange(cnpjLookup);
        return;
      }

      this.setState({ loadingCNPJLookup: true });
      this.cnpjLookupTimeout = setTimeout(async () => {
        try {
          const response = await lookupCompanyByCNPJ(normalized);
          const currentNormalized = (this.state.form?.cnpj || '').replace(/\D/g, '');
          if (currentNormalized !== normalized || this.lastRequestedCnpj !== normalized) {
            return;
          }
          if (response.exists && response.company) {
            const cnpjLookup = { exists: true, companyName: response.company.name, checked: true };
            this.setState({
              loadingCNPJLookup: false,
              cnpjLookup
            });
            this.props.onCnpjLookupChange && this.props.onCnpjLookupChange(cnpjLookup);
            return;
          }

          const cnpjLookup = { exists: false, companyName: '', checked: true };
          this.setState({
            loadingCNPJLookup: false,
            cnpjLookup
          });
          this.props.onCnpjLookupChange && this.props.onCnpjLookupChange(cnpjLookup);
        } catch (error) {
          const currentNormalized = (this.state.form?.cnpj || '').replace(/\D/g, '');
          if (currentNormalized !== normalized || this.lastRequestedCnpj !== normalized) {
            return;
          }
          const cnpjLookup = { exists: false, companyName: '', checked: false };
          this.setState({
            loadingCNPJLookup: false,
            cnpjLookup
          });
          this.props.onCnpjLookupChange && this.props.onCnpjLookupChange(cnpjLookup);
        }
      }, 600);
    }
  
    scrollToFirstError = () => {
      const firstErrorElement = document.querySelector('.errors .error') as HTMLElement | null;
      if (firstErrorElement && typeof firstErrorElement.scrollIntoView === 'function') {
        firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    getFullFormErrors = () => {
      let errors_validators: Record<string, any[]> = {
        fantasy_name: [emptyField(this.state.form.fantasy_name, 'string')],
        // terms_and_conditions: [emptyField(this.state.form.terms_and_conditions, 'string')],
        postcode: [emptyField(this.state.form.postcode, 'string')],
        address_number: [emptyField(this.state.form.address_number, 'string')],
        cnpj: [emptyField(this.state.form.cnpj, 'string')],
        segment_id: [emptyField(this.state.form.segment_id, 'string')],
        company_email: [emptyField(this.state.form.company_email, 'string')],
        phone: [emptyField(this.state.form.phone, 'string')],
        website: [validateOptionalUrl(this.state.form.website, 200)],
        // facebook_link: [validateRegex(this.state.form.facebook_link, /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/, 'URL inválida')],
        // instagram_link: [validateRegex(this.state.form.instagram_link, /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/, 'URL inválida')],
        // linkedin_link: [validateRegex(this.state.form.linkedin_link, /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/, 'URL inválida')],
        // google_link: [validateRegex(this.state.form.google_link, /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/, 'URL inválida')]
      };

      if (!this.state.form.ie_free) {
        errors_validators['ie'] = [emptyField(this.state.form.ie, 'string')];
      }

      // Validar se o CEP está preenchido mas o endereço não foi carregado corretamente
      const postcodeFilled = this.state.form.postcode && this.state.form.postcode.trim() !== '';
      const addressNotLoaded = !this.state.form.street || !this.state.form.address_district || !this.state.form.city || !this.state.form.uf;
      
      if (postcodeFilled && (addressNotLoaded || this.state.cepError)) {
        errors_validators['postcode'] = ['Digite um CEP válido'];
      }

      return formatErrors(errors_validators);
    }

    onSubmit = () => {
      if (this.props.mode === 'cnpj_gate') {
        return this.onSubmitCnpjGate();
      }

      if (this.state.loading) return;

      const errors = this.getFullFormErrors();

      this.setState({ formErrors: errors }, () => {
        if (errorsLength(errors) > 0) {
          this.scrollToFirstError();
        }
      });
  
      if(errorsLength(errors) > 0) return;
  
      try {
        setTimeout(() => {
          this.setState({ sended: true });
          this.props.onSubmit(this.state.form);
        });
      } catch (error) {
        this.setState({ loading: false });
      }
    }

    onSubmitCnpjGate = async () => {
      if (this.state.loadingCNPJLookup) return;

      const errors = formatErrors({
        cnpj: [emptyField(this.state.form.cnpj, 'string'), CNPJValidator(this.state.form.cnpj)]
      });

      this.setState({ formErrors: errors });
      if (errorsLength(errors) > 0) return;

      if (!validateCNPJ(this.state.form.cnpj)) {
        // CNPJ inválido após validações básicas do formulário
        logger.error('Invalid CNPJ format on CNPJ gate submit', undefined, {
          context: 'company_signup_cnpj_gate',
          reason: 'invalid_cnpj_after_validation',
          cnpj_length: (this.state.form.cnpj || '').replace(/\D/g, '').length
        });
        return;
      }

      try {
        this.setState({ loadingCNPJLookup: true });
        const normalized = this.state.form.cnpj.replace(/\D/g, '');
        const response = await lookupCompanyByCNPJ(normalized);

        if (response.exists && response.company) {
          this.props.onCnpjGateResolved && this.props.onCnpjGateResolved('manager', {
            cnpj: response.company.cnpj,
            name: response.company.name
          });
          return;
        }

        const errors = this.getFullFormErrors();
        this.setState({ formErrors: errors }, () => {
          if (errorsLength(errors) > 0) {
            this.scrollToFirstError();
          }
        });

        if (errorsLength(errors) > 0) {
          this.setState({ loadingCNPJLookup: false });
          return;
        }

        this.props.onCnpjGateResolved && this.props.onCnpjGateResolved('legacy', undefined, this.state.form);
      } catch (error) {
        logger.error('Company CNPJ lookup failed', error as any, {
          context: 'company_signup_cnpj_gate',
          step: 'cnpj_lookup'
        });
        this.setState({
          loadingCNPJLookup: false,
          responseData: {
            type: 'error',
            title: 'Erro ao buscar empresa',
            text: 'Não foi possível consultar o CNPJ agora. Tente novamente.'
          }
        });
      }
    }
  
    render() {
      const isCnpjGate = this.props.mode === 'cnpj_gate';
      const cnpjValue = this.state.form.cnpj || '';
      const cnpjFilled = !!cnpjValue && cnpjValue.replace(/\D/g, '').length > 0;
      const cnpjLookupResolved = isCnpjGate && cnpjFilled && this.state.cnpjLookup?.checked && !this.state.loadingCNPJLookup;
      const disableFields = isCnpjGate ? (!cnpjLookupResolved || this.state.cnpjLookup?.exists) : false;
      const showCompanyExists = isCnpjGate && this.state.cnpjLookup?.exists;
      const resolvedCnpj = cnpjValue.replace(/\D/g, '');
      const handleRecruiterLink = () => {
        if (!this.props.onCnpjGateResolved || !resolvedCnpj || !this.state.cnpjLookup?.companyName) return;
        this.props.onCnpjGateResolved('manager', {
          cnpj: resolvedCnpj,
          name: this.state.cnpjLookup.companyName
        });
      };

      return (
        <div className={`form company-data ${disableFields ? 'cnpj-gate-disabled' : ''}`}>
          <div className='form-container'>
            <div className='columns'>
              <div className='column column-first'>
                <div className='field-group field-cnpj'>
                  <Input
                  name='cnpj'
                  label='CNPJ da Empresa'
                  required={true}
                  mask='99.999.999/9999-99'
                  value={this.state.form.cnpj}
                  onChange={this.onCNPJChange}/>
                  <ErrorMessage errors={this.state.formErrors['cnpj']} />
                  {showCompanyExists && (
                    <p className='cnpj-lookup-message'>
                      Empresa já cadastrada.{' '}
                      <button className='cnpj-lookup-link' onClick={handleRecruiterLink} type='button'>
                        Cadastre-se como recrutador(a)
                      </button>
                    </p>
                  )}
                </div>
                <div className='row field-group field-ie'>
                  <div className='flex-1'>
                    <Input
                    name='ie'
                    label='IE Empresa'
                    required={true}
                    mask='99999999999999'
                    value={this.state.form.ie}
                    disabled={disableFields || this.state.form.ie_free}
                    onChange={e => this.setState({ form: { ...this.state.form, ie: e, ie_free: false }, formErrors: { ...this.state.formErrors, ie: [] } })}/>
                  </div>
                  <CheckboxInput
                  name='ie_free'
                  label='Isento'
                  checked={this.state.form.ie_free}
                  disabled={disableFields}
                  onChange={e => this.setState({ form: { ...this.state.form, ie_free: e, ie: e ? '' : this.state.form.ie }, formErrors: { ...this.state.formErrors, ie: [] } })}/>
                  <ErrorMessage errors={this.state.formErrors['ie']} />
                </div>
                <div className='location row field-group field-location'>
                  <img src={locationIcon} alt='location' />
                  <p>Localização</p>
                </div>
                <div className='block field-group field-location-block'>
                    <Input
                    name='postcode'
                    label='CEP da empresa'
                    required={true}
                    mask='99999-999'
                    value={this.state.form.postcode}
                    disabled={disableFields}
                    onChange={e => {this.setState({ form: { ...this.state.form, postcode: e }, formErrors: { ...this.state.formErrors, postcode: [] }, cepError: false }); this.onCEPChange(e)}} />
                    <ErrorMessage errors={this.state.formErrors['postcode']} />
                    <div className='address-part'>
                      <p>Endereço: <span className={this.state.loadingCEP ? 'shimmer' : ''}>{ this.state.loadingCEP ? '' : (this.state.form.street ? this.state.form.street : '-') }</span></p>
                    </div>
                    <div className='address-part'>
                      <p>Bairro: <span className={this.state.loadingCEP ? 'shimmer' : ''}>{ this.state.loadingCEP ? '' : (this.state.form.address_district ? this.state.form.address_district : '-') }</span></p>
                    </div>
                    <div className='address-part'>
                      <p>Cidade / UF: <span className={this.state.loadingCEP ? 'shimmer' : ''}>{ this.state.loadingCEP ? '' : (this.state.form.city ? this.state.form.city+' / '+this.state.form.uf : '-') }</span></p>
                    </div>
                    <div className='row address-row'>
                      <div className='street-number-input-container'>
                        <Input
                        name='address_number'
                        label='N°'
                        required={true}
                        value={this.state.form.address_number}
                        disabled={disableFields}
                        onChange={e => this.setState({ form: { ...this.state.form, address_number: e }, formErrors: { ...this.state.formErrors, address_number: [] } })}/>
                        <ErrorMessage errors={this.state.formErrors['address_number']} />
                      </div>
                      <div className='flex-1'>
                        <Input
                        name='address_complement'
                        label='Complemento'
                        value={this.state.form.address_complement}
                        disabled={disableFields}
                        onChange={e => this.setState({ form: { ...this.state.form, address_complement: e }, formErrors: { ...this.state.formErrors, address_complement: [] } })}/>
                        <ErrorMessage errors={this.state.formErrors['address_complement']} />
                      </div>
                    </div>
                </div>
                <div className='field-group field-em-unit'>
                  <Select
                  name='em_unit'
                  label='Unidade da Escola do Mecânico mais próxima'
                  options={this.state.schoolOptions}
                  value={this.state.form.em_unit}
                  disabled={disableFields}
                  onChange={e => this.setState({ form: { ...this.state.form, em_unit: e } })}/>
                </div>
              </div>
              <div className='column column-second'>
                <div className='field-group field-fantasy-name'>
                  <Input
                  name='fantasy_name'
                  label='Nome da Empresa'
                  required={true}
                  value={this.state.form.fantasy_name}
                  disabled={disableFields}
                  onChange={e => this.setState({ form: { ...this.state.form, fantasy_name: e }, formErrors: { ...this.state.formErrors, fantasy_name: [] } })}/>
                  <ErrorMessage errors={this.state.formErrors['fantasy_name']} />
                </div>
                <div className='field-group field-segment'>
                  <Select
                  name='segment_id'
                  label='Segmento da empresa'
                  required={true}
                  icon={companySegmentIcon}
                  options={this.state.segmentOptions}
                  value={this.state.form.segment_id}
                  disabled={disableFields}
                  onChange={e => this.setState({ form: { ...this.state.form, segment_id: e }, formErrors: { ...this.state.formErrors, segment_id: [] } })}/>
                  <ErrorMessage errors={this.state.formErrors['segment_id']} />
                </div>
                <div className='field-group field-email'>
                  <Input
                  name='company_email'
                  label='E-mail'
                  required={true}
                  icon={emailIcon}
                  value={this.state.form.company_email}
                  disabled={disableFields}
                  onChange={e => this.setState({ form: { ...this.state.form, company_email: e }, formErrors: { ...this.state.formErrors, company_email: [] } })}/>
                  <ErrorMessage errors={this.state.formErrors['company_email']} />
                </div>
                <div className='field-group field-phone'>
                  <Input
                  name='phone'
                  mask='(99) 99999-9999'
                  icon={phoneIcon}
                  type='number'
                  label='Telefone para contato'
                  required={true}
                  value={this.state.form.phone}
                  disabled={disableFields}
                  onChange={e => this.setState({ form: { ...this.state.form, phone: e }, formErrors: { ...this.state.formErrors, phone: [] } })}/>
                  <ErrorMessage errors={this.state.formErrors['phone']} />
                </div>
                <div className='field-group field-website'>
                  <Input
                  name='website'
                  icon={linkIcon}
                  label='Site da empresa'
                  maxLength={200}
                  value={this.state.form.website}
                  disabled={disableFields}
                  onChange={e => this.setState({ form: { ...this.state.form, website: e }, formErrors: { ...this.state.formErrors, website: [] } })}/>
                  <ErrorMessage errors={this.state.formErrors['website']} />
                </div>
                <div className='field-group field-social field-facebook'>
                  <Input
                  name='facebook_link'
                  icon={linkIcon}
                  label='Facebook'
                  value={this.state.form.facebook_link}
                  disabled={disableFields}
                  onChange={e => this.setState({ form: { ...this.state.form, facebook_link: e }, formErrors: { ...this.state.formErrors, facebook_link: [] } })}/>
                  <ErrorMessage errors={this.state.formErrors['facebook_link']} />
                </div>
                <div className='field-group field-social field-instagram'>
                  <Input
                  name='instagram_link'
                  icon={linkIcon}
                  label='Instagram'
                  value={this.state.form.instagram_link}
                  disabled={disableFields}
                  onChange={e => this.setState({ form: { ...this.state.form, instagram_link: e }, formErrors: { ...this.state.formErrors, instagram_link: [] } })}/>
                  <ErrorMessage errors={this.state.formErrors['instagram_link']} />
                </div>
                <div className='field-group field-social field-linkedin'>
                  <Input
                  name='linkedin_link'
                  icon={linkIcon}
                  label='Linkedin'
                  value={this.state.form.linkedin_link}
                  disabled={disableFields}
                  onChange={e => this.setState({ form: { ...this.state.form, linkedin_link: e }, formErrors: { ...this.state.formErrors, linkedin_link: [] } })}/>
                  <ErrorMessage errors={this.state.formErrors['linkedin_link']} />
                </div>
                <div className='field-group field-social field-google'>
                  <Input
                  name='google_link'
                  icon={linkIcon}
                  label='Google'
                  value={this.state.form.google_link}
                  disabled={disableFields}
                  onChange={e => this.setState({ form: { ...this.state.form, google_link: e }, formErrors: { ...this.state.formErrors, google_link: [] } })}/>
                  <ErrorMessage errors={this.state.formErrors['google_link']} />
                </div>
              </div>
            </div>
            <button className='primary submit' onClick={this.onSubmit}>
              {isCnpjGate && this.state.loadingCNPJLookup ? 'Buscando...' : 'Continuar'}
            </button>
          </div>
          <ResponseModal
          render={this.state.responseData}
          type={this.state.responseData?.type}
          title={this.state.responseData?.title}
          text={this.state.responseData?.text}
          onClose={() => this.setState({ responseData: null })} />
        </div>
      )
    }
}